//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import fetch from '@/axios/promise';
    import {DORM, BASIC, JPT_URL} from "@/config/constant"
    import {getFlowTypeList, getFlowInfoById, getExtFieldByExtTypeCode, saveFlowData, updateApprInfo, saveHiElement, getHiEleInfo, delFlowAttachByFileId} from '@/api/flow/flow';
    import {getDicData, getInnerUserData} from '@/api/common/dic';
    // import {FILE_URL} from '@/api/rem/cost/cost';
    import {Toast } from 'mint-ui';
    import Message from 'muse-ui-message';
    import SlipDel from 'vue-slip-delete';
    import promise from '@/axios/promise';

    export default {
        components: {
			SlipDel
		},
        data: function () {
            const generateData = _ => {
                const data = [];
                var cond = {onJob:'是'};
                var condition = {'condition':JSON.stringify(cond)};
                getInnerUserData(condition).then(response => {
                    for(var i=0;i<response.length;i++){
                        data.push({
                            label: response[i].name,
                            key: response[i].name + "-" +response[i].username
                        });
                    }
                });
                return data;
            };
            return {
                isOperation: false,//操作按钮是否禁用（除驳回）
                isReject: false,
                docked: false,
                position: true,
                isDisable: false,//表单是否禁用
                isChangeFlowType: false,
                parentDicItem: [],
                childDicItem: [],
                //当前用户
                currUserName: "",
                currUserCode: "",
                currApprover: "",//当前待审批人
                currApproverCode: "",//当前待审批人编码

                /** 选择审批人员弹出框 **/
                dialogChoosePersonVisible: false,//审批人员选择框显示
                selQuery: {queryText: ""},//查询参数
                actEles: [],//审批节点
                //xin
                personSourceData: [],// 待选择的人员数据
                personOptions: [],
                personAddData: [],// 已选择的数据
                selectedPerson: "",//已选人员
                checkboxPer: [],

                /** 审批 **/
                //待办页传递参数
                businessKey:this.$route.query.businessKey,
                taskId:this.$route.query.taskId,
                taskTopic:this.$route.query.taskTopic,
                taskType:this.$route.query.taskType,
                showConfirm:this.$route.query.showConfirm,
                taskDefinitionKey:this.$route.query.taskDefinitionKey,
                variables:{},
                status: 'S',
                msg:"",
                taskVisible:false,
                nextTaskDatas:[],
                operType: this.$route.query.operType,

                /** 表单信息 **/
                form: {
                    id: this.$route.query.businessKey,
                    flowAttachments: []
                },
                extForm: {},
                childForm: {},
                dialogChildExtVisible: false,//子表表单显示
                rules1: {},
                rules: {
                    flowTypeCode:[
                        { validate: (val) => !!val, message: '请输入流程类别'}
                    ],
                    flowTitle:[
                        { validate: (val) => !!val, message: '请输入流程标题'}
                    ],
                },//表单必填规则设置
                options1: [],
                extfieldConfig: [],//拓展字段配置信息
                childExtFieldConfig: [],//从表拓展字段配置信息
                tableData4: [],//从表数据

                /** 附件相关  上传照片**/
                imgList: [],
                loading: false,
                file_URL:'',
                fillList: [],
                datasdatas: new FormData(),
                size: 0,
                files:0
            }

        },
        created() {
            console.log(this.businessKey);
            console.log(this.taskId);
            console.log(this.taskTopic);
            console.log(this.taskType);
            console.log(this.showConfirm);
            console.log(this.taskDefinitionKey);
            //取得流程类别
            var type = {"configType": "flow","enableState": "1"};
            this.getFlowTypeList(type);

            //通过id获取数据信息
            var flowId = this.form.id;
                var query = {flowId: flowId};
                this.getFlowInfoById(query);

            //获取当前用户
            this.getCurrUserInfo();

            //获取内部人员列表
            this.getInnerUserData();
            this.$previewRefresh();
            promise({
                url: DORM + "/expense/selectDictionType",
                method: "get",
                async: false,
                params: {
                    type: "fileUrl"
                }
            }).then(res => {
                console.log(res[0].dicCode);
                this.file_URL = res[0].dicCode
            });
        },
        methods: {
            //********************************************上传照片***********************************************//
            //删除图片
            delFileClick(fileId, fillList){
                for(var i=0;i<fillList.length;i++){
                    if(fillList[i].fileId == fileId){
                        this.fillList.splice(i,1);
                        break;
                    }
                }
                var docIds=[];
                docIds.push(fileId);
                fetch({
                    url:JPT_URL+ "/zuul" + BASIC + "/doc/delete",
                    params:{"docIdStr":JSON.stringify(docIds)},
                    method:"get"
                }).then(res=>{
                    debugger
                    if(res.code=="0"){
                        //同时删除flow_attachment 根据fileId
                        var query = {'fileId': fileId};
                        delFlowAttachByFileId(query).then(res =>{
                            Toast({message: '图片已删除', duration: 1500, position: 'middle', className: "success"});
                        });
                    }else{
                        Toast({message: '删除失败', duration: 1500, position: 'middle', className: "error"});
                    }
                });
            },
            //调用相册&相机
            fillFileClick(fillIndex) {
                this.fillShowActionSheet(fillIndex);
            },
            //点击事件，弹出选择摄像头和相册的选项
			fillShowActionSheet(fillIndex) {
				let bts = [{
					title: "拍照"
				}, {
					title: "从相册选择"
				}];
				var _thiss = this
				plus.nativeUI.actionSheet({
						cancel: "取消",
						buttons: bts
					},
					function(e) {
						if(e.index == 1) {
							_thiss.fillGetImage(fillIndex);
						} else if(e.index == 2) {
							_thiss.fillGalleryImgs(fillIndex);
						}
					}
				);
            },
            //调用手机摄像头并拍照
			fillGetImage(fillIndex) {
				var _this = this;
				let cmr = plus.camera.getCamera();
				cmr.captureImage(function(p) {
					console.log('摄像头前')
					console.log(p)
					plus.io.resolveLocalFileSystemURL(p, function(entry) {
						_this.loading = true;
						$('.loadingHeight').css('display', 'block');
						$('.container').css('overflow', 'hidden');

						var file = {};
						console.log(p)
						plus.zip.compressImage(entry.toLocalURL(), entry.name);
						entry.file(function(path) {
							console.log("P__" + JSON.stringify(path));
							var fileData = JSON.stringify(path);

							file.lastModifiedDate = fileData.lastModifiedDate;
							var reader = new plus.io.FileReader();
							reader.readAsDataURL(path);
							reader.onloadend = function(event) {
								console.log(event)
								var base64 = event.target.result;
								_this.dealImage(base64, function(base) {
									//直接将获取到的base64的字符串，放到一个image标签中就可看到测试后的压缩之后的样式图了
									// document.getElementById("transform").src = base;
									file.src = base;
									// console.log("压缩后：" + base.length / 1024 + " " + base);　　　　
								})
								var fileName = event.target.fileName;
								if(fileName.indexOf("/") >= 0) //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
								{
									file.name = fileName.substring(fileName.lastIndexOf("/") + 1, fileName.length);
								} else {
									file.name = fileName;
								}
								var blob, jsonFile
								setTimeout(function() {
									blob = _this.dataURLtoBlob(file.src);
									jsonFile = _this.blobToFile(blob, file.name)
									console.log('jsonFile')
									console.log(jsonFile.filename)
								}, 1000)
								setTimeout(function() {
									var formData = new FormData();
									formData.append("file", jsonFile);
									formData.append("infoFid", _this.form.id);
									formData.append("direCode", 'flow');
									promise({
										url: JPT_URL + "/zuul" + BASIC + '/doc/upload',
										method: "post",
										async: true,
										data: formData,
									}).then(response => {
                                        debugger
										console.log('调用成功')
										console.log(response);
                                        let obj = {
                                            'fileId': response.data[0].id,
                                            'name': response.data[0].fileName,
                                            'fileUrl': response.data[0].fileUrl,
                                            'contentCode': response.data[0].contentCode
                                        };
                                        _this.fillList.push(obj);
                                        _this.$previewRefresh();
                                        _this.loading = false;
                                        $('.loadingHeight').css('display', 'none');
                                        $('.container').css('overflow', 'auto');
                                        $('.fillImg').removeClass('displNone')
                                    });
								}, 2000)
							};
						})
					}, function(e) {
						plus.nativeUI.toast("读取拍照文件错误：" + e.message);
					});
				}, function(e) {}, {
					filter: 'image'
				});
				// cmr.captureImage(function(path){
				//   this.rotateImg(path);
				// }, function getPhotoE(error){
				//   // mui.toast('拍照失败');
				// });
            },
            //从相册选择照片
			fillGalleryImgs(fillIndex) {
				var _this = this;
				console.log(_this.imgList)
				plus.gallery.pick(function(e) {
					console.log(e)
					let name = e.substr(e.lastIndexOf('/') + 1);
					console.log(name)
					plus.zip.compressImage(e, name);
					console.log('相册')
					plus.io.resolveLocalFileSystemURL(e, function(entry) {
						_this.loading = true;
						$('.loadingHeight').css('display', 'block');
						$('.container').css('overflow', 'hidden');
						var file = {};
						console.log(e)
						plus.zip.compressImage(entry.toLocalURL(), entry.name);
						// console.log('相册')
						// console.log(entry)
						// console.log('相册base64')
						entry.file(function(path) {
							console.log("P__" + JSON.stringify(path));
							var fileData = JSON.stringify(path);
							file.lastModifiedDate = fileData.lastModifiedDate;
							var reader = new plus.io.FileReader();
							reader.readAsDataURL(path);
							reader.onloadend = function(event) {
								console.log(event)
                                var base64 = event.target.result;
								_this.dealImage(base64, function(base) {
									//直接将获取到的base64的字符串，放到一个image标签中就可看到测试后的压缩之后的样式图了
									// document.getElementById("transform").src = base;
									file.src = base;
									// console.log("压缩后：" + base.length / 1024 + " " + base);　　　　
								})
								// file.src=event.target.result;
								var fileName = event.target.fileName;
								if(fileName.indexOf("/") >= 0) //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
								{
									file.name = fileName.substring(fileName.lastIndexOf("/") + 1, fileName.length);
								} else {
									file.name = fileName;
								}
								var blob, jsonFile
								setTimeout(function() {
									blob = _this.dataURLtoBlob(file.src);
									jsonFile = _this.blobToFile(blob, file.name)
									console.log('jsonFile')
									console.log(jsonFile.filename)
								}, 2000)
								setTimeout(function() {
									var formData = new FormData();
									formData.append("file", jsonFile);
									formData.append("infoFid", _this.form.id);
									formData.append("direCode", 'flow');
									promise({
										url: JPT_URL + "/zuul" + BASIC + '/doc/upload',
										method: "post",
										async: true,
										data: formData,
									}).then(response => {
										console.log('调用成功')
										console.log(response);
                                        let obj = {
                                            'fileId': response.data[0].id,
                                            'name': response.data[0].fileName,
                                            'fileUrl': response.data[0].fileUrl,
                                            'contentCode': response.data[0].contentCode
                                        };
                                        _this.fillList.push(obj1)
										_this.$previewRefresh()
										_this.loading = false;
										$('.loadingHeight').css('display', 'none');
										$('.container').css('overflow', 'auto');
										$('.fillImg').removeClass('displNone')
									});
								}, 3000)
							};
						})
					}, function(e) {
						plus.nativeUI.toast("读取拍照文件错误：" + e.message);
					});
				}, function(e) {}, {
					filter: "image"
				});
				// console.log('相册')

            },
            dealImage(path, callback) {
				var img = new Image();
				img.src = path;
				img.onload = function() {
					//默认按比例压缩
					var w = this.width,
						h = this.height;
					console.log('照片宽度')
					console.log(this.width)
					console.log(this.height)
					console.log('值类型')
					console.log(typeof this.width)
					console.log(this)
					console.log(this.size);
					if(w > 4096) {
						w = 4095
					}
					if(h > 4096) {
						h = 4095
					}
					var quality; // 默认图片质量为0.7
					if(w < 1000 || h < 1000) {
						quality = 0.8
						console.log('0.8')
					} else {
						quality = 0.3
						console.log('0.3')
					}

					//生成canvas
					var canvas = document.createElement('canvas');
					var ctx = canvas.getContext('2d');

					// 创建属性节点
					canvas.setAttribute("width", w);
					canvas.setAttribute("height", h);

					ctx.drawImage(this, 0, 0, w, h);
					// quality值越小，所绘制出的图像越模糊
					var base64 = canvas.toDataURL('image/jpeg', quality);
					// 回调函数返回base64的值
					callback(base64);
				};
            },
            dataURLtoBlob(dataurl) {
				var arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while(n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				console.log('blob')
				return new Blob([u8arr], {
					type: mime
				});
            },
            //将blob转换为file
			blobToFile(theBlob, fileName) {
				var objFile = new File([theBlob], fileName, {
					type: "image/jpeg"
				});
				console.log(fileName)
				// theBlob.lastModifiedDate = new Date();
				// theBlob.filename = fileName;
				console.log('file')
				return objFile;
			},
            //********************************************上传照片结束***********************************************//

            //获取数据字典item
            getDicData(type,cateCode){
                var condition = {cateCode: cateCode};
                getDicData(condition, true).then(response => {
                    if (type == 'parent'){
                        this.parentDicItem = response;
                    }else if(type == 'child'){
                        this.childDicItem = response;
                    }
                });
            },
            //获取当前用户
            getCurrUserInfo(){
                //获取当前用户
                fetch({
                    url: BASIC + '/user/currUserInfo',
                    method: 'GET',
                }).then(response => {
                    this.currUserCode = response.username;
                    this.currUserName = response.name;
                });
            },
            // 获取内部人员
            getInnerUserData(){
                var cond = {onJob:'是'};
                var condition = {'condition':JSON.stringify(cond)};
                getInnerUserData(condition).then(response => {
                    debugger
                    // console.log(response);
                    this.personOptions = response;
                    this.personSourceData = response;
                });
            },
            //取得流程类别
            getFlowTypeList(type) {
                getFlowTypeList(type).then(response => {
                    this.options1 = response.data;
                });
            },
            //通过id获取流程信息
            getFlowInfoById(query){
                getFlowInfoById(query).then(response => {
                    debugger
                    this.form = response.data;
                    //设置页面是否可编辑
                    if (this.taskType == 'done'){//已读、非草稿状态  || this.form.apprState != '草稿'
                        this.isDisable = true;
                        this.isOperation = true;
                        this.isReject = true;
                    }else{//待办下
                        if (this.form.apprState == '草稿' || this.form.apprState == '审批驳回'){
                            this.isDisable = false;
                            this.isOperation = false;
                            this.isReject = true;
                        }else{
                            this.isDisable = true;
                            this.isOperation = false;
                            this.isReject = false;
                        }
                    }

                    //流程模板已生成不得修改流程类别
                    if (this.form.processKey != null && this.form.processKey != "" && this.form.processKey != undefined){
                        this.isChangeFlowType = true;
                    }
                    //根据流程类别渲染该流程下的拓展字段
                    var flowTypeCode = this.form.flowTypeCode;
                    var query = {
                        configType: "flow",
                        extTypeCode: flowTypeCode,
                        enableState: "1"
                    };
                    this.getExtFieldByExtTypeCode(query);
                    //从表
                    if (this.form.childExtField != null && this.form.childExtField != "" && this.form.childExtField != undefined){
                        this.tableData4 = JSON.parse(this.form.childExtField);
                    }
                    //渲染审批节点
                    if (this.form.actElements != null && this.form.actElements != "" && this.form.actElements != undefined){
                        this.actEles = JSON.parse(this.form.actElements);
                    }
                    //获取附件信息
                    if (response.data.flowAttachments != null) {
                        for (let i = 0; i < response.data.flowAttachments.length; i++) {
                            var file = {};
                            file.fileId = response.data.flowAttachments[i].fileId;
                            file.name = response.data.flowAttachments[i].attName;
                            file.fileUrl = response.data.flowAttachments[i].attPath;
                            file.contentCode = response.data.flowAttachments[i].contentCode;
                            this.fillList.push(file);
                        }
                    }
                    this.form.flowAttachments = [];
                });
            },
            //根据流程类别渲染该流程下的拓展字段
            getExtFieldByExtTypeCode(query) {
                getExtFieldByExtTypeCode(query).then(response => {
                    var data = response.data;
                    //取得扩展字段渲染表单----------------------------------------------
                    if(data[0].extField != "" && data[0].extField != null && data[0].extField != undefined){
                        $('.extDetailClass').show();
                        var extfieldConfig = JSON.parse(data[0].extField);
                        if (extfieldConfig.length != 0 && extfieldConfig != null && extfieldConfig != undefined){

                            for (var i=0;i<extfieldConfig.length;i++){
                                if (extfieldConfig[i].fieldType == 'dic'){//如果是dic类型的字段，
                                    this.getDicData('parent',extfieldConfig[i].fieldRule.rule1);
                                }else if(extfieldConfig[i].fieldType == 'upload'){//如果是上传类型
                                    this.getDicData('upload',"fileUrl");
                                }
                            }
                            //为每个组件赋值
                            var extFieldStr = this.form.extField;
                            if (extFieldStr != null && extFieldStr != "" && extFieldStr != undefined){
                                var extField = JSON.parse(extFieldStr);
                                for (var i = 0;i<extfieldConfig.length;i++){
                                    var fieldCode = extfieldConfig[i].fieldCode;
                                    for (var key in extField) {
                                        if (key == fieldCode){
                                            extfieldConfig[i].defaultValue = extField[key];
                                        }
                                    }
                                }
                            }else{
                                for (var i = 0;i<extfieldConfig.length;i++){
                                    var fieldCode = extfieldConfig[i].fieldCode;
                                    var fieldType = extfieldConfig[i].fieldType;
                                    if (fieldType == 'checkbox'){
                                        extfieldConfig[i].defaultValue = JSON.parse(extfieldConfig[i].defaultValue);
                                    }
                                }
                            }
                            this.extfieldConfig = extfieldConfig;
                        }
                    }else{
                        $('.extDetailClass').hide();
                    }
                    //取得子表拓展字段渲染子表-----------------------------------------------------
                    if(data[0].childExtField != "" && data[0].childExtField != undefined && data[0].childExtField != null){
                        $('.childExtClass').show();
                        var childExtFieldConfig = JSON.parse(data[0].childExtField);
                        if (childExtFieldConfig != null && childExtFieldConfig != undefined && childExtFieldConfig.length != 0){
                            for (var i=0;i<childExtFieldConfig.length;i++){
                                if (childExtFieldConfig[i].fieldType == 'dic'){
                                    this.getDicData('child',childExtFieldConfig[i].fieldRule.rule1);
                                }
                            }
                            this.childExtFieldConfig = childExtFieldConfig;
                        }
                    }else{
                        $('.childExtClass').hide();
                    }
                    //从表
                    if (this.form.childExtField != null && this.form.childExtField != "" && this.form.childExtField != undefined){
                        this.tableData4 = JSON.parse(this.form.childExtField);
                        this.renderChildTabel(this.childExtFieldConfig, this.tableData4);
                    }
                });
            },
            renderChildTabel(childExtFieldConfig,childExtField){
                let html = "";
                for (var j = 0 ; j <childExtField.length;j++){
                    html += `<mu-list-item class=' LookCostDetail costBottomBorder' style='padding-left:2%;text-align: left;'>`
                    for (var i = 0 ; i<childExtFieldConfig.length;i++){//:key="i.infoFid"
                        html += `
                                    <mu-row class='didiCost borderBottomCCC'>
                                        <mu-col style='height: 0.45rem;padding-top:0.05rem;'>
                                            <span class='costNumb' style="font-weight:500">${childExtFieldConfig[i].fieldName}：</span>
                                            <span class='costNumb'>${childExtField[j][childExtFieldConfig[i].fieldCode]}</span>
                                            <div style='clear:both;'></div>
                                        </mu-col>
                                    </mu-row>
                        `;
                    }
                    html += `</mu-list-item>`
                }
                $('#child_table').html(html)
            },

            //删除从表
            del(index){

            },
            //滑动
			slipOpen(vm) {
				// 无需手动关闭
			},
            //修改流程类别
            changeFlowType(value) {
                var flowTypeCode = value;
                var query = {
                    configType: "flow",
                    extTypeCode: flowTypeCode,
                    enableState: "1"//启用状态为是
                };
                this.getExtFieldByExtTypeCode(query);
                var extTypeList = this.options1;
                for (var i = 0 ;i<extTypeList.length; i++){
                    if (extTypeList[i].extTypeCode == value){
                        this.form.flowType = extTypeList[i].extType;
                    }
                }
                //取得当前登录发起该流程的历史审批节点
                var query1 = {flowHiElement: JSON.stringify({flowTypeCode: this.form.flowTypeCode,submitterCode: this.currUserCode})}
                getHiEleInfo(query1).then(res =>{
                    if (res.data != null){
                        if (res.data.actElements != null && res.data.actElements != "" && res.data.actElements != undefined){
                            this.form.actElements = JSON.parse(res.data.actElements);
                            this.actEles = JSON.parse(res.data.actElements);
                        }else {
                            this.form.actElements = [];
                            this.actEles = [];
                        }
                    }else{
                        this.form.actElements = [];
                        this.actEles = [];
                    }
                });
            },
            /** 选择审批人员 **/
            valuePer(item){
                return item.name + "-" + item.username;
            },
            //勾选人员
            check(checkboxPer,index,dataList){
                debugger
                this.personAddData = [];
                this.selectedPerson = "";
                var vm = this;
                vm.checkboxPer.forEach(function (item){
                    debugger
                    var arr = item.split("-");
                    var data = {
                        name: arr[0],
                        username: arr[1]
                    };
                    vm.personAddData.push(data);
                    var selectedPerson = vm.selectedPerson;
                    if (selectedPerson == '' || selectedPerson == undefined || selectedPerson == null){
                        selectedPerson = arr[0];
                    }else{
                        selectedPerson += "," + arr[0];
                    }
                    vm.selectedPerson = selectedPerson;
                });
            },
            //添加审批人员-确认
            choosePersonClick(){
                var personAddData = this.personAddData;
                if (personAddData.length > 0){
                    var actEles = [];
                    for (var i = 0 ; i<personAddData.length ; i++){
                        var userName = personAddData[i].username;
                        var realName = personAddData[i].name;
                        var candidateUser = JSON.stringify([{userName: userName, realName: realName}]);
                        if (actEles.length == 0){//即第一个节点
                            //开始连接线
                            var startSeqFlowEle = {
                                elementType : "SequenceFlow",
                                elementId : "seqId-"+ this.uuid(),
                                source : "startevent1",
                                target: "startut"+this.currUserCode,
                                conditionExpression: "${status == 1}"
                            };
                            //当前登录人节点
                            var currUtEle = {
                                elementType : "UserTask",
                                elementId : "startut"+this.currUserCode,
                                elementName : "提交人:"+this.currUserName,
                                assignee: this.currUserCode,
                                elementUrl : "/workReport/flowManage/flow_audit",
                                candidateUser: JSON.stringify([{userName: this.currUserCode, realName: this.currUserName}])
                            };
                            //连接线-与当前登录人的连接线
                            var seqFlowEle = {
                                elementType : "SequenceFlow",
                                elementId : "seqId-"+ this.uuid(),
                                source : "startut"+this.currUserCode,
                                target: "ut"+userName,
                                conditionExpression: "${status == 1}"
                            };
                            //选择的节点
                            var utEle = {
                                elementType : "UserTask",
                                elementId : "ut"+userName,
                                elementName : "审批人:"+realName,
                                assignee: userName,
                                elementUrl : "/workReport/flowManage/flow_audit",
                                candidateUser: candidateUser
                            };
                            actEles.push(startSeqFlowEle);
                            actEles.push(currUtEle);
                            actEles.push(seqFlowEle);
                            actEles.push(utEle);

                        }else {
                            var lastEle = actEles[actEles.length-1];
                            var lastElementId = lastEle.elementId;
                            //连接线
                            var seqFlowEle = {
                                elementType : "SequenceFlow",
                                elementId : "seqId-"+ this.uuid(),
                                source : lastElementId,
                                target: "ut"+userName,
                                conditionExpression: "${status == 1}",
                            };
                            var utEle = {
                                elementType : "UserTask",
                                elementId : "ut"+userName,
                                elementName: "审批人:"+realName,
                                assignee: userName,
                                elementUrl : "/workReport/flowManage/flow_audit",
                                candidateUser: candidateUser
                            };

                            actEles.push(seqFlowEle);
                            actEles.push(utEle);
                        }
                    }
                    this.actEles = actEles;
                    this.dialogChoosePersonVisible = false;
                }else {
                    Toast({message: '请至少选择一位审批人！', duration: 1500, position: 'middle', className: "warning"});
                }
            },
            //添加审批节点
            addElement:function(index, event){
                if (this.form.processKey == null || this.form.processKey == "" || this.form.processKey == undefined){
                    this.personAddData = [];
                    this.checkboxPer = [];
                    var actEles = this.actEles;
                    for(var i = 0;i<actEles.length;i++){
                        if (actEles[i].elementType == 'UserTask' && actEles[i].assignee != this.currUserCode){
                            var perData = {
                                name: actEles[i].elementName.substring(4),
                                username: actEles[i].assignee
                            };
                            this.personAddData.push(perData);
                            this.checkboxPer.push(perData.name+"-"+perData.username);
                        }
                    }
                    var selectedPerson = "";
                    for(var i = 0;i<this.personAddData.length;i++){
                        if(selectedPerson == ""){
                            selectedPerson = this.personAddData[i].name;
                        }else{
                            selectedPerson += "," + this.personAddData[i].name;
                        }
                    }
                    this.selectedPerson = selectedPerson;
                    this.dialogChoosePersonVisible = true;
                }else{
                    Toast({message: '流程模板已生成，不允许添加审批节点', duration: 1500, position: 'middle', className: "warning"});
                }
            },
            //删除审批节点
            delElement(todo, index){
                var maxLen = this.actEles.length;
                //已生成流程模板则不可修改审批节点
                if (this.form.processKey == null || this.form.processKey == "" || this.form.processKey == undefined){
                    //第一个审批节点(当前登录人)不可删除；
                    if (index != 1){
                        if (index < maxLen-1){//如果是中间的节点，删掉本节点与前连接线，将前一个节点与后一个节点相连（修改后连接线）
                            var newSource = this.actEles[index-2].elementId;
                            this.actEles[index+1].source = newSource;
                            this.actEles.splice(index-1, 2);
                        }else{//如果是最后一个节点，删掉本节点与前连接线；
                            this.actEles.splice(index-1, 2);
                        }
                    }else{
                        Toast({message: '第一个审批节点不可删除！', duration: 1500, position: 'middle', className: "warning"});
                    }
                }else{
                    Toast({message: '流程模板已生成，不允许删除审批节点', duration: 1500, position: 'middle', className: "warning"});
                }
                var a = this.actEles;
            },
            closeChoosePersonDialog:function(){
                this.dialogChoosePersonVisible = false;
            },
            //人员搜索
            searchPersonBtn(){
                this.personSourceData = [];
                if(this.selQuery.queryText !== ''){
                    this.personSourceData = [];
                    for(var i=0;i<this.personOptions.length;i++){
                        var item = this.personOptions[i];
                        if(item.name.indexOf(this.selQuery.queryText) !== -1 || item.deptName.indexOf(this.selQuery.queryText) !== -1 ){
                            // deptFlag = false;
                            // personFlag = false;
                            this.personSourceData.push(item);
                        }
                    }
                }else{
                    for(var i=0;i<this.personOptions.length;i++){
                        this.personSourceData.push(this.personOptions[i]);
                    }
                }
            },
            clearFilter(){
                this.selQuery.queryText = "";
                // 重新加载
                this.searchPersonBtn();
            },
            closeChildExtDialog(){
                this.dialogChildExtVisible = false;
            },
            //添加从表数据
            addChildInfo:function(){
                var childExtFieldConfig = this.childExtFieldConfig;
                //添加必填规则设置
                var childForm = {};
                for (var i = 0;i<childExtFieldConfig.length;i++){
                    var item = childExtFieldConfig[i];
                    if(item.defaultValue != null && item.defaultValue != "" && item.defaultValue != undefined){
                        if(item.fieldType == 'datepicker'){
                            childForm[item.fieldCode] = this.dateToString(item.defaultValue);
                        }else{
                            childForm[item.fieldCode] = item.defaultValue;
                        }
                    }else{
                        childForm[item.fieldCode] = "";
                    }
                }
                this.childForm = childForm;
                console.log(this.childForm);
                this.dialogChildExtVisible = true;
            },
            //确认添加扩展信息
            addChildExtConfirm(){
                this.tableData4.push(this.childForm);
                this.renderChildTabel(this.childExtFieldConfig, this.tableData4);
                this.dialogChildExtVisible = false;
            },
            dateToString: function(date){
                var year = date.getFullYear();
                var month =(date.getMonth() + 1).toString();
                var day = (date.getDate()).toString();
                if (month.length == 1) {
                    month = "0" + month;
                }
                if (day.length == 1) {
                    day = "0" + day;
                }
                var dateTime = year + "-" + month + "-" + day;
                return dateTime;
            },
            //设置拓展字段的必填
            setExtFieldRule(){
                var extfieldConfig = this.extfieldConfig;
                //添加必填规则设置
                var rules = {};
                var extForm = {};
                for (var i = 0;i<extfieldConfig.length;i++){
                    var item = extfieldConfig[i];
                    extForm[item.fieldCode] = item.defaultValue;
                    if (item.fieldCheck){
                        if (item.fieldType != 'upload'){
                            var jsonArray = [] , json = {};
                            json.validate = (val) => !!val;
                            json.message = '请输入' + item.fieldName;
                            jsonArray.push(json);
                            rules[item.fieldCode] = jsonArray;
                        }else{
                            // this.fieldBitian = true;
                        }
                    }
                }
                this.rules1 = rules;
                this.extForm = extForm;
            },
            //提交数据
            onSubmit() {
                this.setExtFieldRule();
                setTimeout(() => {
                    this.checkValidate("submit");
                }, 1);
            },
            //驳回数据
            onReject(){
                this.taskVisible=true;//显示流程审批人员选择列表
                this.variables.status= '2';
                this.status = 'E'//驳回
                this.getNextTaskDatas("1");
            },
            checkValidate(type){
                this.$refs['form'].validate().then((result) => {
                    if (result) {
                        this.$refs['extForm'].validate().then((result1) => {
                            if (result1) {
                                debugger
                                var mainForm = this.form;
                                mainForm.extField = JSON.stringify(this.extForm);
                                mainForm.apprState = this.form.apprState;//仅保存数据，不修改状态；
                                mainForm.actElements = JSON.stringify(this.actEles);
                                if (this.tableData4.length > 0){
                                    mainForm.childExtField = JSON.stringify(this.tableData4)//子表信息
                                }
                                if(this.fillList!=[]){
                                    for (var  i = 0; i <this.fillList.length; i++) {
                                        var comAtt={};
                                        comAtt.fileId=this.fillList[i].fileId;
                                        comAtt.attName=this.fillList[i].name;
                                        comAtt.attPath=this.fillList[i].fileUrl;
                                        comAtt.contentCode=this.fillList[i].contentCode;
                                        comAtt.attSuffix=this.fillList[i].name.split(".")[1];
                                        comAtt.attType=this.fillList[i].name.split(".")[1];
                                        mainForm.flowAttachments.push(comAtt);
                                    }
                                }
                                var query = {saveData:JSON.stringify(mainForm)};
                                saveFlowData(query).then(response => {
                                    this.form = response.data;
                                    Toast({message: '保存成功', duration: 1500, position: 'middle', className: "success"});
                                    //将当前登录人发起的该流程类型的审批节点保存至流程审批历史节点表中
                                    var hiQuery = {flowHiElement: JSON.stringify({flowTypeCode: this.form.flowTypeCode,submitterCode: this.currUserCode, actElements: JSON.stringify(this.actEles)})};
                                    saveHiElement(hiQuery).then(res =>{
                                        console.log(res.data);
                                    });
                                    if (type == 'submit'){
                                        this.subForm();
                                    }
                                });
                            }else{
                                return false;
                            }
                        });
                    }else{
                        return false;
                    }
                })
            },
            subForm(){
                // this.taskVisible=true;//显示流程审批人员选择列表
                this.variables.status= '1';
                this.status = 'S'
                this.getNextTaskDatas("0");
            },
            getNextTaskDatas(showConfirm){
                var str=JSON.stringify(this.variables);
                fetch({
                    url:BASIC+"/task/getConfirmInfo?taskId="+this.taskId+"&status="+this.status,
                    method:"post",
                    headers:{"Content-Type": "application/json"},
                    data:str
                }).then(res=>{
                    var code =res.code;
                    if(code==0){
                        this.nextTaskDatas=res.data;
                        var self=this;
                        $.each(this.nextTaskDatas,function(index,row){
                            var taskTpc = '';
                            if(row.actDicTask !== null){
                                taskTpc = row.actDicTask.taskTopic;
                            }
                            var taskTopic = self.getTaskTopic(row.task, taskTpc);
                            row.task.taskTopic=taskTopic;
                        });
                        if(showConfirm == "0"){
                            this.taskConfirm();
                        }
                    }else{
                        Toast({message: res.msg, duration: 1500, position: 'middle', className: "error"});
                    }
                });
            },
            getTaskTopic(task,taskTopicExp) {
                if(task!=null){
                    var commitUser=task.commitUser;
                    if(commitUser==null || commitUser==''){
                        status='F';
                    }
                }
                var taskTopic='';
                if(taskTopicExp==null || taskTopicExp==''){
                    // taskTopic=task.processDefinitionName+":"+task.taskName+":"+task.commitUserName;
                    taskTopic = this.form.flowType + ":" + this.form.flowNum + ":" + task.commitUserName;
                }else{
                    var expArr=taskTopicExp.split(":");
                    for (var i = 0; i < expArr.length; i++) {
                        var exp=expArr[i];
                        if(i==expArr.length-1){
                            if(exp==null || exp==''){
                                continue;
                            }else if(exp=="procName"){
                                taskTopic=taskTopic+task.processDefinitionName;
                            }else if(exp=="taskName"){
                                taskTopic=taskTopic+task.taskName;
                            }else if(exp=="commitUser"){
                                taskTopic=taskTopic+task.commitUserName;
                            }else{

                                var expVal=$("#"+exp).val();
                                taskTopic=taskTopic+expVal;
                            }
                        }else{
                            if(exp==null || exp==''){
                                continue;
                            }else if(exp=="procName"){
                                taskTopic=taskTopic+task.processDefinitionName+":";
                            }else if(exp=="taskName"){
                                taskTopic=taskTopic+task.taskName+":";
                            }else if(exp=="commitUser"){
                                taskTopic=taskTopic+task.commitUserName+":";
                            }else{
                                var expVal=$("#"+exp).val();
                                taskTopic=taskTopic+expVal+":";
                            }
                        }
                    }
                }
                return taskTopic;
            },
            toggleRowSelection(val) {
                var currNextTaskUsers=this.nextTaskDatas[this.Index].users;
                $.each(currNextTaskUsers,function(index,user){
                    var flag=false;
                    $.each(val,function(index,row){
                        if(user.userName==row.userName){
                            flag=true;
                            user.checked=true;
                        }
                    });
                    if(!flag){
                        user.checked=false;
                    }
                });
            },
            taskConfirm:function(){
                //获取页面传递过来的变量
                var map={};
                //审核意见
                //循环获取每个任务的办理人和任务主题
                var topics={};
                var variables=this.variables;
                var flag=0;//0正常 1任务配置 2任务主题 3办理人
                var msg="";
                var vm = this;
                $.each(this.nextTaskDatas,function(index,row){
                    debugger
                    var task=row.task;
                    var taskKey=task.taskDefinitionKey;
                    var taskName=task.taskName;
                    var actDicTask= row.actDicTask;
                    if(taskKey!='end'){
                        if(actDicTask==null){
                            flag=1;
                            msg="请配置该流程的"+taskName+"节点任务信息";
                            return;
                        }else if(actDicTask.taskType==null || actDicTask.taskType==''){
                            flag=1;
                            msg="请配置该流程的"+taskName+"节点任务任务类型";
                            return;
                        }else if(actDicTask.userExpKey==null || actDicTask.userExpKey==''){
                            flag=1;
                            msg="请配置该流程的"+taskName+"节点任务办理人方式";
                            return;
                        }else{
                            //设置任务主题
                            var taskTopic=task.taskTopic;
                            if(taskTopic==null || taskTopic==''){
                                flag=2;
                                msg=taskName+"节点任务主题不能为空";
                                return;
                            }
                            topics[taskKey]=taskTopic;
                            //任务办理人
                            var taskType=actDicTask.taskType;
                            var userExpKey=actDicTask.userExpKey;
                            var data =[];
                            $.each(row.users,function(index,user){
                                var checked=user.checked;
                                data.push(user);
                                // if(checked!=null && checked==true){
                                //     data.push(user);
                                // }
                            });
                            if(taskType=='Multi'){
                                if(data==null || data.length==0){
                                    flag=3;
                                    msg=taskName+"节点任务办理人不能为空";
                                    return;
                                }else {
                                    var userVal="";
                                    for (var i = 0; i < data.length; i++) {
                                        var user=data[i];
                                        if(i==0){
                                            userVal+=user.userName;
                                        }else{
                                            userVal=userVal+","+user.userName
                                        }
                                    }
                                    variables[userExpKey]=userVal;
                                }
                            }else{
                                if(data==null || data.length==0){
                                    flag=3;
                                    msg=taskName+"节点任务办理人不能为空";
                                    return;
                                }else if(data.length>1){
                                    flag=3;
                                    msg=taskName+"节点为单人任务";
                                    return;
                                }else{
                                    variables[userExpKey]=data[0].userName;
                                    vm.currApprover = data[0].realName;
                                    vm.currApproverCode = data[0].userName;
                                }
                            }
                        }
                    }else{
                        var taskTopic=task.taskTopic;
                        if(taskTopic==null || taskTopic==""){
                            taskTopic="结束"
                        }
                        topics.end=taskTopic;
                    }
                });
                if(flag!=0){
                    Toast({message: msg, duration: 1500, position: 'middle', className: "error"});
                    return;
                }
                //任务主题
                //设置流程办理人
                map.taskTopics=topics;
                map.variables=variables;
                debugger
                fetch({
                    url:BASIC+"/task/completeTaskByTaskId?businessKey="+ this.form.id +"&taskId="+this.taskId+"&msg="+this.msg+"&status="+this.status,
                    method:"post",
                    headers:{"Content-Type": "application/json" },
                    data:JSON.stringify(map),
                }).then(res=>{
                    debugger
                    if(res.code==0){
                        this.taskVisible=false;
                        //修改数据审批状态和最后审批人
                        var taskDefinitionKey = this.taskDefinitionKey;
                        var state = this.form.apprState;
                        if (taskDefinitionKey.indexOf("endut") != -1){//说明是最后一个环节
                            state = "已完成";
                        }else {
                            state = "审批中";
                        }
                        if(this.variables.status == '2'){
                            state = "审批驳回";
                        }
                        this.updateApprInfo(state);
                        //返回
                        this.goback();
                    }else{
                        Toast({message: res.msg, duration: 1500, position: 'middle', className: "error"});
                    }
                });
            },
            updateApprInfo(state){
                var flowInfo = {
                    id: this.form.id,
                    apprState: state,
                    currApprover: this.currApprover,
                    currApproverCode: this.currApproverCode
                };
                var query = {flowInfo: JSON.stringify(flowInfo)}
                updateApprInfo(query).then(response => {
                    Toast({message: '保存成功', duration: 1500, position: 'middle', className: "success"});
                    if (state == '已完成'){
                        this.delDIYProcess(response.data.processKey);
                    }
                });
            },
            cancelButton(){
                this.taskVisible=false;
            },
            IndexClick(index){
                this.Index=index;
            },
            //返回列表
            goback() {
                this.$router.go(-1);
            },
            // 获取uuid
            uuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                return uuid;
            }
        }
    }



// WEBPACK FOOTER //
// ./src/view/flow/flowApplyAudit.vue